// extracted by mini-css-extract-plugin
module.exports =  {"time":"_93444fe79c--time--bKmTM"};